import React from 'react';
import MatClntCoreTransactionList from './MatClntCoreTransactionList';

export default function MatClntTxnList() {
  return (
    <MatClntCoreTransactionList
      title="Client Material - All Transactions"
      opTypes={[
        'incoming',
        'transfer',
        'issue',
        'assign',
        'return',
        'sendback',
        'adjustment',
      ]}
    />
  );
}
